import React from 'react';
import { Theme } from '../../Themes/themeProvider/ThemeProvider';
import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { MIcon } from '../Icon';
import {
	CheckboxCheckmark,
	CheckboxCustomIcon,
	CheckboxIcon,
	CheckboxInput,
	CheckboxLabel,
	CheckboxRoot,
} from './styles';
import * as meta from '../../meta-data.json';

export const overrides = (props: any, dataAria: any, dataProps: any, theme: typeof Theme) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const {
		checkmarkIcon,
		checkmarkIconActive,
		autoFocus,
		inputRef,
		labelPlacement,
		isFocused,
		isIndeterminate,
		children,
		error,
		positive,
		size,
		...rest
	} = HTMLAttrs.rest;
	return {
		Root: {
			style: ({ $theme }: any) => {
				return CheckboxRoot($theme, props);
			},
			props: {
				...getBaseCustomProps(props),
				...HTMLAttrs.dataProps,
				'data-epo': `epo-checkbox-${meta.version}`,
				part: `epo-checkbox-${meta.version}`,
				key: props.key,
			},
		},
		Label: {
			style: ({ $theme, $disabled }: any) => {
				return CheckboxLabel($theme, $disabled, props);
			},
		},
		Checkmark: {
			component: props.checkmarkIcon
				? ({ $isFocused, $disabled, $checked }: any) => {
					return (
						//TODO: find a way of using:
						// - theme.checkbox.tickIconFont
						<CheckboxCustomIcon
							isfocused={$isFocused.toString()}
							disabled={$disabled}
							className={'material-icons'}
							checkmarkiconactive={props.checkmarkIconActive}
							checked={$checked}
						>
							{props.checkmarkIcon}
						</CheckboxCustomIcon>
					);
				}
				: undefined,
			style: ({ $theme, $isFocused, $isHovered, $isActive, $disabled, $checked, $isIndeterminate }: any) => {
				return CheckboxCheckmark(
					$theme,
					$isFocused,
					$isHovered,
					$isActive,
					$disabled,
					$checked,
					$isIndeterminate,
					props,
				);
			},
			props: {
				children: (
					<MIcon
						icon={props.checked ? 'check' : props.isIndeterminate ? 'remove' : undefined}
						color="var(--epods--color-text-inverted)"
						size="small"
						style={CheckboxIcon(theme)}
					/>
				),
			},
		},
		Input: {
			style: ({ $theme, $disabled }: any) => {
				return CheckboxInput($theme, $disabled);
			},
			props: {
				...getFormCustomProps(props),
				...HTMLAttrs.ariaProps,
				tabIndex: props.tabIndex || 0,
				name: props.name,
			},
		},
	};
};
